<template>
  <ul v-if="facets && facets.length">
    <li v-if="facets.length > 1">
      <pu-low-results-search-link v-bind="searchLinkPropsWithoutAllFacets">
        <translate>Remove all feature filters</translate>
      </pu-low-results-search-link>
      <translate>or some of them:</translate>
    </li>
    <li v-for="facet in facets" :key="facet.slug">
      <translate>Remove</translate>
      <pu-low-results-search-link
        v-bind="getSearchLinkPropsWithoutFacet(facet.slug)"
      >
        {{ facet.name }}
      </pu-low-results-search-link>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { PuSearchLinkProps } from '../../../pu-links/link-search/PuSearchLinkProps'

const props = defineProps<{
  facetSlugs: string[]
}>()
const facetsStore = useFacetsStoreSetup(usePinia())

const facets = computed(() =>
  props.facetSlugs
    .map((slug) => facetsStore.facetsBySlug(slug))
    .filter((facet) => facet)
    .sort((a, b) => a.name.localeCompare(b.name)),
)

const searchLinkPropsWithoutAllFacets = computed<PuSearchLinkProps>(() => {
  return {
    facet: '',
    modifyFilters: {
      facets: [],
    },
  }
})

function getSearchLinkPropsWithoutFacet(slug: string): PuSearchLinkProps {
  const newFacets = props.facetSlugs.filter((f) => f !== slug)
  return {
    facet: '',
    modifyFilters: { facets: newFacets },
  }
}
</script>

<style scoped>
ul {
  line-height: 2;
  margin: 1em 0;
}
</style>
